import { useState } from 'react';

export const AutoTraderStatusBadge = () => {
  const [autoTraderActive] = useState(true);

  return (
    <div
      className={[
        'flex items-center gap-2 rounded-md px-3.5 py-1.5 text-sm font-semibold text-white',
        autoTraderActive ? 'bg-green-500' : 'bg-zinc-500',
      ].join(' ')}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-white" />
      AUTO-TRADER: {autoTraderActive ? 'ACTIVE' : 'STOPPED'}
    </div>
  );
};

export default AutoTraderStatusBadge;

